export default "__VITE_ASSET__NZUH7x7h__"